/** Retain only validated experiment labels; never store signup details. */
const STORAGE_KEY = "myculture:hero-attribution";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

type HeroAttribution = {
  experiment_id: "hero_v1";
  experiment_variant: "control" | "variant";
  ab_hero_v1: "control" | "variant";
  capturedAt: number;
};

let current: HeroAttribution | null = null;

function isVariant(value: unknown): value is "control" | "variant" {
  return value === "control" || value === "variant";
}

export function captureHeroAttribution(): void {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const experiment = params.get("experiment_id");
  const variant = params.get("experiment_variant");
  const legacy = params.get("ab_hero_v1");
  if (
    (experiment !== null && experiment !== "hero_v1") ||
    (variant !== null && !isVariant(variant)) ||
    (legacy !== null && !isVariant(legacy)) ||
    (variant !== null && legacy !== null && variant !== legacy)
  ) return;
  const selected = variant || legacy;
  if (!isVariant(selected)) return;
  current = {
    experiment_id: "hero_v1",
    experiment_variant: selected,
    ab_hero_v1: selected,
    capturedAt: Date.now(),
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  } catch (_error) {
    // Memory still preserves attribution when browser storage is unavailable.
  }
}

export function getHeroAttribution(): Record<string, string> {
  if (typeof window === "undefined") return {};
  if (!current) {
    try {
      current = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "null");
    } catch (_error) {
      current = null;
    }
  }
  if (
    !current || current.experiment_id !== "hero_v1" ||
    !isVariant(current.experiment_variant) ||
    current.ab_hero_v1 !== current.experiment_variant ||
    !Number.isFinite(current.capturedAt) ||
    Date.now() < current.capturedAt || Date.now() - current.capturedAt > TTL_MS
  ) {
    current = null;
    return {};
  }
  return {
    experiment_id: current.experiment_id,
    experiment_variant: current.experiment_variant,
    ab_hero_v1: current.ab_hero_v1,
  };
}

// Capture the entry URL before the router removes its query parameters.
captureHeroAttribution();
